import axios from "axios";

const api = axios.create({
	baseURL: "https://realizar-back.herokuapp.com/",
	headers: { "x-access-token": localStorage.getItem("@REALIZAR:user_token") },
});

export default api;
